import React from "react";

const Bash_Syntax = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Syntax</h2>
      <p>Bash syntax basics: comments with <code>#</code>, commands separated by newlines or <code>;</code>, variables prefixed with <code>$</code> when referenced, and quoting rules.</p><pre><code># comment
VAR=hello
echo "$VAR"</code></pre>
    </div>
  );
};

export default Bash_Syntax;
